module.exports = __webpack_public_path__ + "img/editIcon.f6e544c6.svg";